import { AS_OF_DATE_CUSTOM, AS_OF_DATE_MONTH_END, AS_OF_DATE_QUARTER_END } from '../../constants/attribution.constants';
import { PerformancePeriodicity } from 'SecuritiesApp/ts/interfaces/attribution.interface';
export const isPeriodicityDisabled = (periodicity, asOfDateOption) => {
    if (asOfDateOption === AS_OF_DATE_MONTH_END || asOfDateOption === AS_OF_DATE_CUSTOM) {
        return periodicity === PerformancePeriodicity.ONE_DAY || periodicity === PerformancePeriodicity.FIVE_DAYS;
    }
    if (asOfDateOption === AS_OF_DATE_QUARTER_END) {
        return [
            PerformancePeriodicity.ONE_DAY,
            PerformancePeriodicity.FIVE_DAYS,
            PerformancePeriodicity.ONE_MONTH,
            PerformancePeriodicity.SIX_MONTHS,
            PerformancePeriodicity.YTD,
            PerformancePeriodicity.TWENTY_YEARS,
        ].includes(periodicity);
    }
    return false;
};
